<template>
    <el-table
        class="table w-100"
        max-height="300"
        stripe
        :data="data"
        v-loading="isLoading">
        <!-- @row-click="selectCompany"> -->
        <el-table-column
            label="Company"
            prop="company.name"
            fixed>
            <template v-slot="scope">
                <div><strong>{{ scope.row.company.name }}</strong></div>
                <div>#{{ scope.row.company.id }}</div>
            </template>
        </el-table-column>
        <el-table-column
            label="Responsible"
            width="300"
            fixed>
            <template v-slot="scope">
                {{ scope.row?.first_name }} {{ scope.row?.last_name }}
            </template>
        </el-table-column>
        <el-table-column
            label="KYC Filled"
            prop="company.kyc_filled"
            sortable
            fixed>
            <template v-slot="scope">
                {{ scope.row.company.kyc_filled ? 'Yes' : 'No' }}
            </template>
        </el-table-column>
        <el-table-column
            label="Trial days remaining"
            prop="company.subscription.trial_start"
            sortable
            fixed>
            <template v-slot="scope">
                {{ calculateTrialDaysRemaining(scope.row.company) }}
            </template>
        </el-table-column>
        <el-table-column
            label="Account Created on"
            prop="created_at"
            sortable
            fixed>
            <template v-slot="scope">
                {{ scope.row.created_at | fixFullDateLocal }}
            </template>
        </el-table-column>
        <el-table-column
            label="Status"
            prop="status"
            width="300"
            sortable
            fixed>
            <template v-slot="scope">
                <div class="d-flex align-items-center">
                    <div class="status-badge"
                         :class="[`status-badge-${parseStatusValue(scope.row.company.kyc_status)}`]">
                    </div>
                    <div class="ml-2">
                        {{ parseStatus(scope.row.company.kyc_status) }}
                    </div>
                </div>
            </template>
        </el-table-column>
        <el-table-column
            fixed="right">
            <template v-slot="scope">
                <div class="d-flex justify-content-center link"
                     @click="selectCompany(scope.row)">
                    Review Account
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { kyc_mixin } from '../../mixins'
export default {
    name: "KycPendingTable",

    mixins: [
        kyc_mixin
    ],

    props: {
        data: {
            type: Array,
            required: true
        },

        parseStatus: {
            type: Function,
            required: true
        },

        parseStatusValue: {
            type: Function,
            required: true
        },

        isLoading: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        selectCompany(row) {
            this.$emit('select-company', row)
        }
    }
}
</script>
